<template>
  <div>
    <component :is="currentComponent">

    </component>
  </div>
</template>

<script>
import Pages from '../pages/index';
import Utils from '../../mixins/utils';
export default {
  name: 'manage',
  created() {
    this.loadComponent(this.$route.params.slug);
  },
  mixins: [Utils],
  watch: {
    '$route.params.slug': {
      handler(val, oldVal) {
        console.log('new slug', val);
        if (this.isPageAccessible(val)) {
          this.loadComponent(val);
        }else{
          this.gotoRoute(this.getInitPage);
          this.loadComponent(this.getInitPage);
        }
      }
    }
  },
  data() {
    return {
      currentComponent: Pages['updates'],
      defaultSlugs: [
        'updates',
        'backups',
        'activityLog',
        'pluginsAndThemes',
        'loginActivity',
        'addons'
      ]
    };
  },
  computed: {
    currentUserInfo(){
      return this.$store.getters.getCurrentUserInfo;
    },
    getInitPage(){
      return this.$store.getters.getInitPage;
    }
  },
  methods: {
    loadComponent(slug) {
      if (this.defaultSlugs.indexOf(slug) > -1) {
        this.currentComponent = Pages[slug];
      }
      else {
        this.currentComponent = () =>
          this.loadAddon(slug).then(module => {
            // this.$store.registerModule(slug, module.default.Store);
            return module.default.Component;
          });
      }
    },
    isPageAccessible(slug){
      if (this.currentUserInfo.accessLevel == 'admin' || slug == 'activityLog' || slug == 'loginActivity'){
        return true;
      }
      if(slug == 'upTimeMonitor'){
        slug = 'uptimeMonitorUptimeRobot';
      }
      if(slug == 'googlepagespeed'){
        slug = 'googlePageSpeed';
      }
      if(slug == 'pluginsAndThemes'){
        slug = 'items';
      }
      if(slug == 'backups'){
        slug = 'createBackup';
      }
      return _.indexOf(this.currentUserInfo.permissions.access, slug) > -1
    },
    gotoRoute(route) {
      this.$router.push({ name: 'Manage', params: { slug: route } });
    },
  }
};
</script>

<style>
</style>
